import Lottie from 'lottie-react';
import dataAnimation from '@shared/assets/lottie-anim.json';
import { useSelector } from 'react-redux';

export default function MainPreloader() {
  const { isLoading } = useSelector((state) => state.preloader);

  if (!isLoading) return null;

  return (
    <Lottie className="lottie-preloader" animationData={dataAnimation} loop />
  );
}
